import type { ReduxModuleDefinition } from '@exodus/redux-dependency-injection';

import id from './id.js';
import initialState from './initial-state.js';
import eventReducers from './reducers.js';
import selectorDefinitions from './selectors.js';

const playgroundSbtReduxDefinition = {
  id,
  type: 'redux-module',
  initialState,
  eventReducers,
  selectorDefinitions,
} as const satisfies ReduxModuleDefinition;

export default playgroundSbtReduxDefinition;
